<template>
    <el-container class="is-vertical">
        <el-card shadow="never">
            <el-form ref="form" :model="form">
                <el-form-item label-width="100px" label="网站标题" prop="appTitle" required>
                    <el-input maxlength="20" placeholder="请输入网站标题" v-model="form.appTitle"></el-input>
                </el-form-item>
                <el-form-item label-width="100px" label="网站描述" required>
                    <el-input type="textarea" v-model="form.appDesc"></el-input>
                </el-form-item>
                <el-row type="flex" justify="end">
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-row>
            </el-form>
        </el-card>
    </el-container>
</template>

<script>
export default {
    name: "page-config",
    data() {
        return {
            form: {
                appTitle: "",
                appDesc: ""
            }
        };
    },
    created() {
        this.fetchConfig();
    },
    methods: {
        fetchConfig() {
            this.axios.get("/admin/resource/config").then(config => {
                this.form = config;
            });
        },
        onSubmit() {
            this.axios.post("/admin/saveConfig", this.form).then(
                () => {
                    this.$message.success("保存配置成功！");
                },
                () => {
                    this.$message.error("保存配置失败！");
                }
            );
        }
    }
};
</script>

<style></style>
